export const ClientDetailsSegmentsIds = {
  clientDetailsSegmentDocs: 'clientDetailsSegmentDocs',
  clientDetailsSegmentAddNewDeal: 'clientDetailsSegmentAddNewDeal',
  clientDetailsSegmentShareMultiform: 'clientDetailsSegmentShareMultiform',
};
